import { useEffect } from 'react';
import { useMediaQuery } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useLocation } from 'react-router-dom';

// Components
import PopUpErrorDevice from 'components/@efz/PopUpErrorDevice';

// Services
import { isDefined } from 'services/util/auxiliaryUtils';

// Stores
import { useSidebarStore } from 'stores/sidebar';

import SidebarContent from './Content';
import { StyledSidebar } from './StylesSidebar';

const Sidebar = () => {
    const location = useLocation();
    const matches = useMediaQuery('(min-width:1366px)', { noSsr: true });
    const isMobile = useMediaQuery('(max-width:575px)', { noSsr: true });

    const {
        isSidebarPermanent,
        sidebarOpen,
        showErrorDevice,
        actions: { setSidebarOpen, setShowErrorDevice, handleLocationChange },
    } = useSidebarStore();

    const headerHeight = document.getElementById('app-header')?.clientHeight ?? 0;

    useEffect(() => {
        handleLocationChange(location.pathname, isMobile, matches);
    }, [location.pathname]); // eslint-disable-line

    return (
        <>
            <ClickAwayListener onClickAway={() => isMobile && isSidebarPermanent && setSidebarOpen(false)}>
                <StyledSidebar
                    $open={sidebarOpen}
                    $headerHeight={headerHeight}
                    anchor="left"
                    open={sidebarOpen}
                    onClose={() => setSidebarOpen(false)}
                    className="efz-sidebar-container"
                    variant={isSidebarPermanent ? 'permanent' : 'temporary'}
                    PaperProps={{ elevation: 0 }}
                >
                    <SidebarContent headerVisible={headerHeight > 0} />
                </StyledSidebar>
            </ClickAwayListener>

            {isDefined(showErrorDevice) && (
                <PopUpErrorDevice setShowErrorDevice={setShowErrorDevice} title={showErrorDevice.title} content={showErrorDevice.content} />
            )}
        </>
    );
};

export default Sidebar;
